<template>
    <fieldset class="contact">
        <my-input
            label="First name"
            id="name_first"
            :required="true"
            type="text"
            v-model="$v.myContact.name_first.$model"
            :validator="$v.myContact.name_first"
            errorMessage="First name is required"
        />

        <my-input
            label="Last name"
            id="name_last"
            :required="true"
            type="text"
            v-model="$v.myContact.name_last.$model"
            :validator="$v.myContact.name_last"
            errorMessage="Last name is required"
        />

        <my-input
            label="Email"
            id="email"
            :required="true"
            type="email"
            v-model="$v.myContact.email.$model"
            :validator="$v.myContact.email"
            errorMessage="Valid email address is required"
        />

        <my-input
            label="Phone"
            id="phone"
            :required="true"
            type="text"
            v-model="$v.myContact.phone.$model"
            :validator="$v.myContact.phone"
            errorMessage="Phone number is required"
        />
<!--
        <my-input
            label="Address"
            id="address"
            :required="true"
            type="text"
            v-model="$v.myContact.address1.$model"
            :validator="$v.myContact.address1"
            errorMessage="Address is required"
        />

        <my-input
            label="Address 2"
            id="address2"
            type="text"
            v-model="$v.myContact.address2.$model"
        />

        <my-input
            label="City"
            id="city"
            :required="true"
            type="text"
            v-model="$v.myContact.city.$model"
            :validator="$v.myContact.city"
            errorMessage="City is required"
        />

        <my-input
            label="State"
            id="state"
            :required="true"
            type="text"
            v-model="$v.myContact.state.$model"
            :validator="$v.myContact.state"
            errorMessage="State is required"
        />

        <my-input
            label="ZIP code"
            id="zip"
            :required="true"
            type="text"
            v-model="$v.myContact.zip.$model"
            :validator="$v.myContact.zip"
            errorMessage="ZIP code is required"
        />
-->
    </fieldset>
</template>

<script>
import MyInput from '../../_components/form/MyInput.vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

export default {
    components: {
        MyInput,
    },
    mixins: [ validationMixin ],
    props: {
        testName: {
            type: String,
        },
        contact: {
            type: Object,
        },
    },
    data: function () {
        return {
            myContact: Object.assign({
                name_first: '',
                name_last: '',
                email: '',
                phone: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
            }, this.contact),
        };
    },
    validations: {
        myContact: {
            name_first: { required },
            name_last: { required },
            email: { required, email },
            phone: { required },
            address1: { },
            address2: { },
            city: { },
            state: { },
            zip: { },
        },
    },
    watch: {
        myContact: {
            deep: true,
            handler(cur, prev) {
                this.$emit('validity', !this.$v.myContact.$invalid);
                if (!this.$v.myContact.$invalid) {
                    this.$emit('update', this.myContact);
                }
            },
        },
    },
    methods: {
        touch() {
            this.$v.$touch();
        },
    }
}
</script>

<style lang="scss">
.contact {
    fieldset {
        &.field-body {
            padding: 0;
        }

        &.stateZip {
            display: inline-block;
            border: 0;

            input {
                width: 6em;
            }
        }
    }
}
</style>
